import React, { useState } from "react";
import { camelCase, formateDate_dd_month_yy } from "../../../../constants";
import { formatNum } from "../../../../oscar-pos-core/constants";
import { OrderReturnModal } from "../../../common/Modals";
import { ParagraphText, UBButton } from "../../../../Libraries";
import { toast } from "react-toastify";
import {
  GET_RETURN_ORDER_DETAILS_BY_ID,
  PATCH_ACCEPT_SHIP_ORDER,
} from "../../../../apis/configuration";

import { analytics, triggerLogEvent } from "../../../../config/firebase";
import { Box } from "@mui/material";
import styles from "./styles.module.css";

const ReturnListItem = ({ data }) => {
  const { handleOrderStatus, handleGetOrder, updateLoad, order, index, I18n } =
    data || {};
  const {
    customer_courier_name,
    customer_tracking_id,
    created_at_timestamp,
    order_status,
    order_number,
    total,
    note,
    id,
  } = order || {};

  const [returnModal, setReturnModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [date, setDate] = useState(null);

  /**
   * handling accpet, ship and view order
   * @returns calling functions based on type;
   */
  const handleAction = (e, type) => {
    e.stopPropagation();
    if (type == "view") handleGetOrder(GET_RETURN_ORDER_DETAILS_BY_ID, { id });
    else if (order_status == "received_customer_return") handleReadyToShip();
    else toggleReturnModal(true);
  };

  /**
   * calling api to accept order
   * @returns update order
   */
  const handleReturnOrder = () =>
    handleOrderStatus(PATCH_ACCEPT_SHIP_ORDER, {
      shipping_date: Number(date),
      accept: true,
      id,
    }).then(() => {
      toast.success("Dispatch date set successfully", {
        className: "successToast",
      });
      toggleReturnModal();
      triggerLogEvent(analytics, "sc_order_returns_accept", {});
    });

  /**
   * calling api to ship order
   * @returns update order
   */
  const handleReadyToShip = () => {
    setLoading(true);
    handleOrderStatus(PATCH_ACCEPT_SHIP_ORDER, {
      ready_to_ship: true,
      id,
    })
      .then(() =>
        toast.success("Order shipped successfully", {
          className: "successToast",
        })
      )
      .finally(() => setLoading(false));
  };

  /**
   * Receive date to change
   * @returns update date state;
   */
  const onChangeText = (value) => setDate(new Date(value));

  /**
   * Receive toggle to toggle return order modal
   * @returns toggle modal & clear date;
   */
  const toggleReturnModal = (toggle = false) => {
    setReturnModal(toggle);
    setDate("");
  };

  return (
    <Box
      id={`saddar_order_list_${index}`}
      className={`invoiceListTableBody AccountItemListWrapper ${styles.OrderTableHeader}`}
      onClick={(e) => {
        if (returnModal) return;
        handleAction(e, "view")
      }}
    >
      <Box
        className={`invListTableHeaderCol sevenColumn ${styles.OrderTableBox} textLeft sidebarOption ${styles.headerContainer}`}
      >
        <ParagraphText className="fontSize14 fontWeight400 textLeft newFontColor">
          {formateDate_dd_month_yy(created_at_timestamp)}
        </ParagraphText>
      </Box>

      <Box className={`invListTableHeaderCol sevenColumn ${styles.OrderTableBox} textLeft`}>
        <ParagraphText className="fontSize14 fontWeight400 truncateOneLine textLeft newFontColor displayFlex">
          {order_number}
        </ParagraphText>
      </Box>

      <Box className={`invListTableHeaderCol sevenColumn ${styles.OrderTableBox} textLeft`}>
        <ParagraphText className="fontSize14 fontWeight400 truncateOneLine textLeft newFontColor">
          {customer_tracking_id ? (
            <>
              <span className="truncateOneLine barclayBlueColor">
                {customer_tracking_id}
              </span>
              <span className="truncateOneLine mediumGrayColor">
                {customer_courier_name}
              </span>
            </>
          ) : (
            <span>-</span>
          )}
        </ParagraphText>
      </Box>

      <Box className={`invListTableHeaderCol sevenColumn ${styles.OrderTableBox} textLeft`}>
        <ParagraphText className="fontSize14 fontWeight400 truncateOneLine textLeft newFontColor">
          {camelCase(note) || "-"}
        </ParagraphText>
      </Box>
      <Box className={`invListTableHeaderCol sevenColumn ${styles.OrderTableBox} textLeft`}>
        <ParagraphText className="fontSize14 fontWeight400 truncateOneLine textLeft newFontColor">
          {camelCase(`${I18n[order_status]}`)}
        </ParagraphText>
      </Box>
      <Box className={`invListTableHeaderCol sevenColumn ${styles.OrderTableBox} rightLeft`}>
        <ParagraphText className="fontSize14 fontWeight400 truncateOneLine rightLeft newFontColor amountColumnInnerWrapper">
          Rs. {formatNum(total)}
        </ParagraphText>
      </Box>

      <Box
        className={`invListTableHeaderCol sevenColumn ${styles.OrderTableBox} textCenter`}
      >
        <ParagraphText className="fontSize14 fontWeight400 truncateOneLine textCenter newFontColor">
          <div className={styles.OrderTableAction}>
            {order_status == "pending" ||
              order_status == "received_customer_return" ? (
              <UBButton
                id="return_item_view_btn"
                className={`fontSize12 ubPrimaryButton textUppercase ${styles.actionBtn}`}
                onClick={handleAction}
                title={
                  order_status == "pending"
                    ? I18n.accept_small
                    : I18n.ready_to_ship
                }
                loading={loading}
              />
            ) : null}
          </div>
        </ParagraphText>
      </Box>
      <OrderReturnModal
        header={{ title: "select_dispatch_date" }}
        body={{
          placeholderText: I18n.select_dispatch_date,
          toggle: returnModal,
          toggleReturnModal,
          selected: date,
          onChangeText,
        }}
        footer={[{
          data: {

            className: "ubSecondaryButton",
            title: I18n.cancel,
            onClick: () => { triggerLogEvent(analytics, "sc_order_return_cancel"); toggleReturnModal(); },
            id: `return_cancel`,
          },
          data: {
            disabled: !date ? true : false,
            onClick: () => { triggerLogEvent(analytics, "sc_order_return_confirmed"); handleReturnOrder(); },
            title: I18n.save,
            className: "ubPrimaryButton",
          },
        }
        ]}
      />
    </Box>
  );
};

export default ReturnListItem;
